export const getEffectiveCancelsAt = (item, subscription) => {
  if (item?.cancels_at != null) return item.cancels_at;
  if (subscription?.cancels_at != null) return subscription.cancels_at;
  return null;
};
export const rangeFitsInterval = (range, interval) => {
  if (!range?.[0] || !range?.[1]) return true;
  const start = new Date(range[0]);
  start.setHours(0, 0, 0, 0);
  const end = new Date(range[1]);
  end.setHours(0, 0, 0, 0);
  const maxEnd = new Date(start);
  if (interval === "year") maxEnd.setFullYear(maxEnd.getFullYear() + 1);
  else maxEnd.setMonth(maxEnd.getMonth() + 1);
  return end <= maxEnd;
};

export const intervalLabel = (interval) => (interval === "year" ? "yearly" : "monthly");
